/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import client from "@kubb/plugin-client/clients/axios";
import type {
	GetTokenLeaderboardV1StatsLeaderboardTokensGetQueryResponse,
	GetTokenLeaderboardV1StatsLeaderboardTokensGetQueryParams,
	GetTokenLeaderboardV1StatsLeaderboardTokensGet422,
} from "../models/GetTokenLeaderboardV1StatsLeaderboardTokensGet.ts";
import type {
	RequestConfig,
	ResponseErrorConfig,
} from "@kubb/plugin-client/clients/axios";
import type {
	QueryKey,
	QueryClient,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";

export const getTokenLeaderboardV1StatsLeaderboardTokensGetSuspenseQueryKey = (
	params: GetTokenLeaderboardV1StatsLeaderboardTokensGetQueryParams,
) =>
	[
		"v5",
		{ url: "/v1/stats/leaderboard/tokens" },
		...(params ? [params] : []),
	] as const;

export type GetTokenLeaderboardV1StatsLeaderboardTokensGetSuspenseQueryKey =
	ReturnType<
		typeof getTokenLeaderboardV1StatsLeaderboardTokensGetSuspenseQueryKey
	>;

/**
 * @summary Get Token Leaderboard
 * {@link /v1/stats/leaderboard/tokens}
 */
export async function getTokenLeaderboardV1StatsLeaderboardTokensGetSuspenseHook(
	params: GetTokenLeaderboardV1StatsLeaderboardTokensGetQueryParams,
	config: Partial<RequestConfig> & { client?: typeof client } = {},
) {
	const { client: request = client, ...requestConfig } = config;

	const res = await request<
		GetTokenLeaderboardV1StatsLeaderboardTokensGetQueryResponse,
		ResponseErrorConfig<GetTokenLeaderboardV1StatsLeaderboardTokensGet422>,
		unknown
	>({
		method: "GET",
		url: "/v1/stats/leaderboard/tokens",
		baseURL: "https://api.sparkscan.io",
		params,
		...requestConfig,
	});
	return res.data;
}

export function getTokenLeaderboardV1StatsLeaderboardTokensGetSuspenseQueryOptionsHook(
	params: GetTokenLeaderboardV1StatsLeaderboardTokensGetQueryParams,
	config: Partial<RequestConfig> & { client?: typeof client } = {},
) {
	const queryKey =
		getTokenLeaderboardV1StatsLeaderboardTokensGetSuspenseQueryKey(params);
	return queryOptions<
		GetTokenLeaderboardV1StatsLeaderboardTokensGetQueryResponse,
		ResponseErrorConfig<GetTokenLeaderboardV1StatsLeaderboardTokensGet422>,
		GetTokenLeaderboardV1StatsLeaderboardTokensGetQueryResponse,
		typeof queryKey
	>({
		enabled: !!params,
		queryKey,
		queryFn: async ({ signal }) => {
			config.signal = signal;
			return getTokenLeaderboardV1StatsLeaderboardTokensGetSuspenseHook(
				params,
				config,
			);
		},
	});
}

/**
 * @summary Get Token Leaderboard
 * {@link /v1/stats/leaderboard/tokens}
 */
export function useGetTokenLeaderboardV1StatsLeaderboardTokensGetSuspenseHook<
	TData = GetTokenLeaderboardV1StatsLeaderboardTokensGetQueryResponse,
	TQueryData = GetTokenLeaderboardV1StatsLeaderboardTokensGetQueryResponse,
	TQueryKey extends
		QueryKey = GetTokenLeaderboardV1StatsLeaderboardTokensGetSuspenseQueryKey,
>(
	params: GetTokenLeaderboardV1StatsLeaderboardTokensGetQueryParams,
	options: {
		query?: Partial<
			UseSuspenseQueryOptions<
				GetTokenLeaderboardV1StatsLeaderboardTokensGetQueryResponse,
				ResponseErrorConfig<GetTokenLeaderboardV1StatsLeaderboardTokensGet422>,
				TData,
				TQueryKey
			>
		> & { client?: QueryClient };
		client?: Partial<RequestConfig> & { client?: typeof client };
	} = {},
) {
	const {
		query: { client: queryClient, ...queryOptions } = {},
		client: config = {},
	} = options ?? {};
	const queryKey =
		queryOptions?.queryKey ??
		getTokenLeaderboardV1StatsLeaderboardTokensGetSuspenseQueryKey(params);

	const query = useSuspenseQuery(
		{
			...(getTokenLeaderboardV1StatsLeaderboardTokensGetSuspenseQueryOptionsHook(
				params,
				config,
			) as unknown as UseSuspenseQueryOptions),
			queryKey,
			...(queryOptions as unknown as Omit<UseSuspenseQueryOptions, "queryKey">),
		},
		queryClient,
	) as UseSuspenseQueryResult<
		TData,
		ResponseErrorConfig<GetTokenLeaderboardV1StatsLeaderboardTokensGet422>
	> & { queryKey: TQueryKey };

	query.queryKey = queryKey as TQueryKey;

	return query;
}
